import React from 'react';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Menu, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import Authentication from 'services/Authentication';
import { useRootStore } from 'stores';
import { WithTooltip } from 'components/WithTooltip';

interface Props {
  collapsed: boolean;
}

const AppAuthMenu: React.FC<Props> = ({ collapsed }: Props) => {
  const store = useRootStore();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => setAnchorEl(null);
  const userName =
    ('' + store.user.user?.firstName + '' + store.user.user?.lastName
      ? `${store.user.user?.firstName} ${store.user.user?.lastName}`
      : null) ||
    store.user.user?.email ||
    store.user.user?.id ||
    'Unknown';
  const logoutHandle = () => Authentication.signOut();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clickHandler = (event: any) => setAnchorEl(event.currentTarget);
  return (
    <>
      <List>
        <WithTooltip title={userName} placement="right" enabled={collapsed}>
          <ListItem button component="button" onClick={clickHandler} data-auto-id="auth-account">
            <ListItemIcon>
              <AccountCircleIcon data-auto-id="account-circle-icon" />
            </ListItemIcon>
            <ListItemText primary={userName} />
          </ListItem>
        </WithTooltip>
        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={logoutHandle} data-auto-id="auth-logout">
            Logout
          </MenuItem>
        </Menu>
      </List>
    </>
  );
};

export const AppAuthMenuContainer = observer(AppAuthMenu);
